import React from 'react';
import { connect } from 'react-redux';
import HomePage from './HomePage.component';

export const mapStateToProps = (state, ownProps) => {
  const linkType = '_spa';
  return {
    linkType
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    push: ownProps.history.push,
    replace: ownProps.history.replace
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
